import { render } from "./fadeBillDetail.vue?vue&type=template&id=984565e2&scoped=true&ts=true"
import script from "./fadeBillDetail.vue?vue&type=script&lang=ts"
export * from "./fadeBillDetail.vue?vue&type=script&lang=ts"

import "./fadeBillDetail.vue?vue&type=style&index=0&id=984565e2&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-984565e2"]])

export default __exports__